import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { candidaciesMinimalQueryKey } from "@/hooks/queries/useGetCandidaciesMinimal";
import { CandidacyStatus, MinimalCandidacy } from "@/types";

// Mirrors guac's `candidaciesEligibleForAgentWhere` + owned filter. Pass an
// ownerUserId to scope the flip to a single owner (resume-for-me); omit it to
// flip every owned shortlist candidacy (resume-for-all).
export const useSetShortlistCandidaciesAgentActive = () => {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  return (ownerUserId?: number) => {
    queryClient.setQueriesData(
      { queryKey: candidaciesMinimalQueryKey(currentCompanyId, currentJobId) },
      (cachedData?: MinimalCandidacy[]): MinimalCandidacy[] | undefined => {
        if (!cachedData) return cachedData;

        return cachedData.map((candidacy) => {
          const isEligible =
            candidacy.lastCandidacyStatusChange.toStatus ===
              CandidacyStatus.SHORTLIST &&
            !candidacy.stafferAgentActive &&
            candidacy.owners.length > 0;
          const matchesOwner =
            ownerUserId === undefined ||
            candidacy.owners.some((owner) => owner.userId === ownerUserId);

          return isEligible && matchesOwner
            ? { ...candidacy, stafferAgentActive: true }
            : candidacy;
        });
      },
    );
  };
};
